import { getOrMakeUnitDefinitionFromMdsSiMarkup } from '@metservicedev/cf-units';
import React from 'react';

import LatexElement from '../../../../utils/latexElement';
import filterDatasetsAndCapabilities from './filterDatasetsAndCapabilities';

const renderVerticalHeading = ({ heading, rowSpan, databilities, datasets, rotateVerticalLabels }) =>
    heading.databilities.map((datability, i) => {
        const { wholeCapability, capUnit } = filterDatasetsAndCapabilities({ databilities, databilityId: datability, datasets });
        const unit = (heading.databilityUnits && heading.databilityUnits[i]) || getOrMakeUnitDefinitionFromMdsSiMarkup(capUnit).unit;
        const latexUnit = (unit && getOrMakeUnitDefinitionFromMdsSiMarkup(unit).niceLatex) || '';
        const customUnitLabel = (heading.databilityUnitLabels && heading.databilityUnitLabels[i]) || heading.databilityUnits[i];
        const unitLabel = customUnitLabel === unit ? LatexElement(latexUnit) : LatexElement(customUnitLabel);

        return (
            <th rowSpan={rowSpan} key={`${heading.id}-${i}`} className='bordered'>
                <div className={(rotateVerticalLabels && 'rotate-this-outer') || null}>
                    <div className={(rotateVerticalLabels && 'rotate-this') || null}>
                        {(heading.databilityLabels && heading.databilityLabels[i]) || (wholeCapability && wholeCapability.display_name_short) || ''}{' '}
                        {!heading.hideUnits[i] && unitLabel}
                    </div>
                </div>
            </th>
        );
    });

export default renderVerticalHeading;
